import { render, staticRenderFns } from "./AsorRbu.vue?vue&type=template&id=4aa8e300"
import script from "./AsorRbu.vue?vue&type=script&lang=js"
export * from "./AsorRbu.vue?vue&type=script&lang=js"
import style0 from "./AsorRbu.vue?vue&type=style&index=0&id=4aa8e300&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports